<div>
  <div mat-dialog-title>{{ 'Authentication Log' | translate:locale.language }}</div>
  <div mat-dialog-content>
    <div>
      {{ 'This log includes events that may be useful for diagnosing/troubleshooting authentication issues.' | translate:locale.language }}
    </div>
    @if (results === null) {
      <mat-spinner></mat-spinner>
    } @else {
      <mat-table [dataSource]="results">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'Event' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>
      
        <!-- EvtTime Column -->
        <ng-container matColumnDef="evtTime">
          <th mat-header-cell *matHeaderCellDef>{{ 'Date' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.evtTime | fixDate | date: 'short' }} </td>
        </ng-container>
      
        <!-- UserId Column -->
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>{{ 'User' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.userId }} </td>
        </ng-container>
      
        <!-- AuthTime Column -->
        <ng-container matColumnDef="authTime">
          <th mat-header-cell *matHeaderCellDef>{{ 'Auth' }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.authTime | fixDate | date: 'short' }} </td>
        </ng-container>
      
        <!-- ExpTime Column -->
        <ng-container matColumnDef="expTime">
          <th mat-header-cell *matHeaderCellDef>{{ 'Exp.' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.expTime | fixDate | date: 'short' }} </td>
        </ng-container>
      
        <!-- TokenType Column -->
        <ng-container matColumnDef="tokenType">
          <th mat-header-cell *matHeaderCellDef>{{ 'Token' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.tokenType }} </td>
        </ng-container>
      
        <!-- IdpType Column -->
        <ng-container matColumnDef="idpType">
          <th mat-header-cell *matHeaderCellDef>{{ 'IDP' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.idpType }} </td>
        </ng-container>
      
        <!-- Message Column -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>{{ 'Message' | translate:locale.language }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.message }} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: columns;"></tr>
      </mat-table>
      @if (results?.length === 0) {
        <div class="empty-events">{{ 'No events' | translate:locale.language }}</div>
      }
    }
  </div>

  <div mat-dialog-actions class="button-row right">
    <button mat-raised-button color="warn" id="clear" (click)="onClear()">{{ 'Clear Events' | translate:locale.language }}</button>
    <button mat-raised-button color="primary" id="close" mat-dialog-close cdkFocusInitial>{{ 'Close' | translate:locale.language }}</button>
  </div>
</div>